import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "posRe"
}
const _hoisted_2 = {
  key: 0,
  class: "fl"
}
const _hoisted_3 = {
  key: 0,
  class: "fl"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "fl"
}
const _hoisted_7 = ["href"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "fl"
}
const _hoisted_10 = {
  key: 0,
  class: "fl"
}
const _hoisted_11 = ["href"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 1,
  class: "fl"
}
const _hoisted_14 = ["href"]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 2,
  class: "pointer fl dgrey"
}
const _hoisted_17 = {
  href: "/tos",
  target: "_blank",
  class: "dgrey"
}
const _hoisted_18 = {
  href: "/privacy_policy",
  target: "_blank",
  class: "dgrey"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "fl" }, "に同意し、", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.noShowAny())
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.Util.isPresent(_ctx.aform))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_ctx.hasTos())
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("a", {
                      href: _ctx.Util.getUrl(_ctx.aform.terms_of_service_url),
                      target: "_blank",
                      class: "pointer dgrey",
                      rel: "noopener noreferrer",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goTosUrl && _ctx.goTosUrl(...args)))
                    }, _toDisplayString(_ctx.tosName()), 9, _hoisted_4),
                    (_ctx.hasPP() || _ctx.showWaaqTos())
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, "・"))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.hasPP())
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("a", {
                      href: _ctx.Util.getUrl(_ctx.aform.privacy_policy_url),
                      target: "_blank",
                      class: "pointer dgrey",
                      rel: "noopener noreferrer",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goPPUrl && _ctx.goPPUrl(...args)))
                    }, _toDisplayString(_ctx.ppName()), 9, _hoisted_7),
                    (_ctx.showWaaqTos())
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, "・"))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_ctx.Util.isPresent(_ctx.room?.room_setting))
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_ctx.hasTos())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("a", {
                        href: _ctx.Util.getUrl(this.room?.room_setting?.terms_of_service_url),
                        target: "_blank",
                        class: "pointer dgrey",
                        rel: "noopener noreferrer",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goTosUrl && _ctx.goTosUrl(...args)))
                      }, _toDisplayString(_ctx.tosName()), 9, _hoisted_11),
                      (_ctx.hasPP() || _ctx.showWaaqTos())
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, "・"))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.hasPP())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("a", {
                        href: _ctx.Util.getUrl(this.room?.room_setting?.privacy_policy_url),
                        target: "_blank",
                        class: "pointer dgrey",
                        rel: "noopener noreferrer",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goPPUrl && _ctx.goPPUrl(...args)))
                      }, _toDisplayString(_ctx.ppName()), 9, _hoisted_14),
                      (_ctx.showWaaqTos())
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, "・"))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
        (_ctx.showWaaqTos())
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("a", _hoisted_17, _toDisplayString(_ctx.hasTos() || _ctx.hasPP() ? `waaq` : ``) + "利用規約", 1),
              _createTextVNode("・"),
              _createElementVNode("a", _hoisted_18, _toDisplayString(_ctx.hasTos() || _ctx.hasPP() ? `waaq` : ``) + "プライバシーポリシー", 1)
            ]))
          : _createCommentVNode("", true),
        _hoisted_19
      ]))
    : _createCommentVNode("", true)
}